import { Navigate } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'

const RedirectToRoutePage = () => {
  const { navigation } = useNavigation()
  const { performanceFeatureAvailability } = usePerformanceModuleContext()

  if (performanceFeatureAvailability.canSeeReviews) {
    return <Navigate replace to={navigation.performance.reviews.fullPath()} />
  }

  if (performanceFeatureAvailability.canSeeGoals) {
    return <Navigate replace to={navigation.performance.goals.fullPath()} />
  }

  if (performanceFeatureAvailability.canSeeCompetencies) {
    return <Navigate replace to={navigation.performance.competencies.fullPath()} />
  }

  if (performanceFeatureAvailability.canSeeReviewProcess) {
    return <Navigate replace to={navigation.performanceProcess.reviews.fullPath()} />
  }

  return <NotFound />
}

export default RedirectToRoutePage
